const PrivacyPolicy = () => {
  return <div className="body__container">PrivacyPolicy</div>;
};

export default PrivacyPolicy;
